import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export const DeployTransformationInitiatedNotification = ({
    id,
    database,
    schema,
    table,
    onDismiss
}) => {
    const { t } = useTranslation();
    const target = `${database}.${schema}`;

    return (
        <Snackbar onDismiss={onDismiss} id={id} variant={SnackbarVariant.DEFAULT} autoHideEnabled>
            <SnackbarMessage>
                {t('deployTransformation:notifications.Initiated', {
                    table,
                    target
                })}
            </SnackbarMessage>
        </Snackbar>
    );
};

DeployTransformationInitiatedNotification.propTypes = {
    id: PropTypes.string.isRequired,
    database: PropTypes.string.isRequired,
    schema: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired
};
